import React, { useEffect, useRef, useState } from "react";

import style from "./MelkType.module.css";

export function MelkTypeBtn(props){
    let [isOpen, setIsOpen] = useState(false);
    let containerRef = useRef();
    let [selectedUsage, setSelectedUsage] = useState(0);

    function handleClickOutside(ev){
        if (containerRef.current && !containerRef.current.contains(ev.target)){
            setIsOpen(false)
        }
    }

    useEffect(() => {
        window.addEventListener("mousedown", handleClickOutside);

        return () => {
            window.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

    useEffect(() => {
        setSelectedUsage(props.selected);
    }, []);

    /*useEffect(() => {
        props.setFunction(selectedUsage);
    }, [selectedUsage])*/

    function selectUse(use){
        if (selectedUsage == use){
            setSelectedUsage(0);
            props.setFunction(0);
            return;
        }
        setSelectedUsage(use);
        props.setFunction(use);
    }

    return <div className={`${style.container}`} ref={containerRef}>
        <div className={`${style.button}`} onClick={() => {setIsOpen(!isOpen)}}>
            <div className={`${style.button_text}`}>
                {selectedUsage != 0? props.categories.find(c => c.id == selectedUsage)?.title || "نوع ملک" : "نوع ملک"}
            </div>
            <div className={`${style.button_icon}`}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{width: "20px", height: "20px"}}><path d="M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z"/></svg>
            </div>
        </div>
        <div className={`${style.content}`} dir="rtl" hidden={!isOpen}>
            {
                props.categories.map((category) => {
                    return <div className={`${style.content_item} ${selectedUsage == category.id? style.content_item_active : ""}`} onClick={() => selectUse(category.id)}>
                            {category.title}
                        </div>
                })
            }
        </div>
    </div>
}